const { css } = require('styled-components');
const LimitedSelectMenuPaper = require('./LimitedSelectMenuPaper');

const DropdownOptionStyles = module.exports = {};

const OPTION_MIN_HEIGHT_PX = 44;
const MENU_LIST_PADDING_Y_PX = 8;
const MENU_PAPER_BORDER_Y_PX = 2;

DropdownOptionStyles.DEFAULT_VISIBLE_MENU_ITEMS = 6;

DropdownOptionStyles.menuPaperSx = {
    border: '1px solid',
    borderColor: 'divider',
    boxSizing: 'border-box',
    maxWidth: 'min(520px, calc(100vw - 32px))'
};

DropdownOptionStyles.getVisibleMenuItemCount = (optionCount = 0) => {

    const count = Array.isArray(optionCount) ? optionCount.length : Number(optionCount);

    if (!Number.isFinite(count) || count < 0) {
        return 0;
    }

    return Math.min(count, DropdownOptionStyles.DEFAULT_VISIBLE_MENU_ITEMS);
};

DropdownOptionStyles.getLimitedMenuMaxHeight = (
    visibleItemCount = DropdownOptionStyles.DEFAULT_VISIBLE_MENU_ITEMS
) => OPTION_MIN_HEIGHT_PX * DropdownOptionStyles.getVisibleMenuItemCount(visibleItemCount)
    + MENU_LIST_PADDING_Y_PX * 2
    + MENU_PAPER_BORDER_Y_PX;

DropdownOptionStyles.limitedVisibleItemsMenuProps = (
    visibleItemCount = DropdownOptionStyles.DEFAULT_VISIBLE_MENU_ITEMS
) => {

    const maxHeight = DropdownOptionStyles.getLimitedMenuMaxHeight(visibleItemCount);

    return {
        slots: {
            paper: LimitedSelectMenuPaper
        },
        PaperProps: {
            style: {
                maxHeight,
                overflow: 'hidden'
            },
            sx: {
                ...DropdownOptionStyles.menuPaperSx
            }
        }
    };
};

DropdownOptionStyles.mergeLimitedMenuProps = (
    menuProps = {},
    visibleItemCount = DropdownOptionStyles.DEFAULT_VISIBLE_MENU_ITEMS
) => {

    const limitedMenuProps = DropdownOptionStyles.limitedVisibleItemsMenuProps(visibleItemCount);
    const paperProps = menuProps.PaperProps || {};
    const limitedPaperProps = limitedMenuProps.PaperProps || {};

    return {
        ...limitedMenuProps,
        ...menuProps,
        slots: {
            ...limitedMenuProps.slots,
            ...(menuProps.slots || {})
        },
        PaperProps: {
            ...limitedPaperProps,
            ...paperProps,
            style: {
                ...limitedPaperProps.style,
                ...(paperProps.style || {})
            },
            sx: {
                ...limitedPaperProps.sx,
                ...(paperProps.sx || {})
            }
        }
    };
};

DropdownOptionStyles.option = css`
    align-items: flex-start !important;
    line-height: 1.35 !important;
    min-height: ${OPTION_MIN_HEIGHT_PX}px !important;
    padding-left: 14px !important;
    padding-right: 14px !important;
    white-space: normal !important;
    overflow-wrap: anywhere;
    transition: background-color 120ms ease, box-shadow 120ms ease;

    &.Mui-selected,
    &[aria-selected='true'] {
        background-color: ${({ theme }) => theme.palette.action.hover} !important;
        box-shadow: inset 3px 0 0 ${({ theme }) => theme.palette.primary.light};
    }

    &:hover,
    &.Mui-focused,
    &.Mui-focusVisible,
    &.Mui-selected:hover,
    &.Mui-selected.Mui-focused,
    &[aria-selected='true']:hover,
    &[aria-selected='true'].Mui-focused {
        background-color: ${({ theme }) => `${theme.palette.primary.main}14`} !important;
        box-shadow: inset 3px 0 0 ${({ theme }) => theme.palette.primary.main};
    }

    &.Mui-disabled,
    &[aria-disabled='true'] {
        box-shadow: none;
    }
`;

DropdownOptionStyles.specifyOption = css`
    &[data-specify-option='true'] {
        margin-top: 4px;
        border-top: 1px solid ${({ theme }) => theme.palette.divider};
        color: ${({ theme }) => theme.palette.text.primary};
    }
`;
